// extracted by mini-css-extract-plugin
module.exports = {"fadeIn":"AssistantApp_fadeIn__1SyZr","loader":"AssistantApp_loader__dBPQB","load3":"AssistantApp_load3__hDyCt"};